export default __webpack_public_path__ + "static/media/DefaultBlogCover.196d3b66.png";